module.exports = __webpack_public_path__ + "static/media/report_img3@2x.22c1e932.png";